var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CritereBase',{attrs:{"selected":_vm.selected},on:{"select":(value) => _vm.$emit('select', value)}},[_vm._v(" Tiers apporteur ")])
}
var staticRenderFns = []

export { render, staticRenderFns }